var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center justify-content-center flex-column flex-grow-1 text-muted font-lg"},[_c('div',{staticClass:"mt-5"},[_c('i',{staticClass:"font-4xl",class:`icon-${_vm.icon}`})]),_c('div',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }